import { Product } from "../models/Product";
import { getApi, postApiFiles } from "./Api";


export const getAllCardsInventary = async (page?:number, limit?:number, name?:string, category?:string, franchise?:string, status?:string) => {
    try{
        return await getApi
        <{products: Product[], total:number, page:number, last_page:number}>
        (`products?page=${page || 1}&limit=${limit || 10}&name=${name || ""}&category=${category || ""}&franchise=${franchise || ""}&status=${status || ""}`)
    }
    catch(error){
        throw error;
    }
}

export const createNewProduct = async (data:FormData)=> {
    try{
        return await postApiFiles("products",data)
    }
    catch(error){
        throw error;
    }
}